import styled from 'styled-components';

export const CardWrapper = styled.div<any>`
    box-sizing: border-box;
    border: ${({ borderColor }) => `1px solid ${borderColor}`};
    border-radius: 4px;
    background-color: #fff;
    width: 100%;
    border-left-color: ${({ borderColor }) => borderColor};
    border-left-width: 7px;
    flex: 1;
    margin-bottom: 30px;
    img {
        cursor: pointer;
    }

    @media screen and (max-width: 800px) {
        margin-bottom: 20px;
    }
`;

export const CardContentWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 7px;
`;

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const Content = styled.div`
    font-size: 14px;
    letter-spacing: 0;
    line-height: 16px;
`;
